import React from 'react';
import { FarmerQuestionnaireActions } from '@redux/Services/FarmersQuestionnaire/actions';
import {
  FarmersQuestionnaireContainer,
  PageHeaderContainer,
  PageSubtitle,
  SuccessModalButtonContainer,
  SuccessModalContainer,
  SuccessModalDescription
} from '@applicationKYC/FarmersQuestionnaire/farmersQuestionnaire.style';
import { useFarmersQuestionnaire } from '@applicationKYC/FarmersQuestionnaire/useFarmersQuestionnaire';
import { PageHeader } from '@applicationKYC/LegalEntityQuestionnaire/screens/renderPage/renderPage.style';
import { FarmersStepper } from '@applicationKYC/FarmersQuestionnaire/components/farmersStepper/farmersStepper';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@single-platform/button';
import { Modal } from '@single-platform/components';
import { SuccessLogo } from '@applicationKYC/FarmersQuestionnaire/assets/images';
import { FarmersStepperSkeleton } from '@applicationKYC/FarmersQuestionnaire/farmersSkeleton';

export const farmSubmitHandler = async (
  questionnaireData,
  data,
  dispatch,
  questionnaireId,
  section
) => {
  questionnaireData[section] = data;

  await dispatch(
    FarmerQuestionnaireActions.updateFarmerInformation(questionnaireId, questionnaireData)
  );
};

export const FarmersQuestionnaire = () => {
  const {
    farmerSteps,
    application,
    loading,
    isApplicationLoading,
    stepListReady,
    farmerStepsReady,
    successModalOpen,
    successModalData,
    handleModalClose,
    handleModalSubmit,
    questionnaireSubmitHandler
  } = useFarmersQuestionnaire();
  const { t } = useTranslation();

  if (loading || isApplicationLoading || !stepListReady || !farmerStepsReady) {
    return <FarmersStepperSkeleton />;
  }

  return (
    <FarmersQuestionnaireContainer>
      {!loading && !isApplicationLoading && (
        <>
          <PageHeaderContainer>
            <PageHeader>
              <Trans
                t={t}
                i18nKey="farmers_questionnaire_header"
                values={{
                  username: `${application?.representative?.firstName} ${application?.representative?.lastName}`
                }}
              />
            </PageHeader>
            <PageSubtitle>{t('farmers_questionnaire_subheader')}</PageSubtitle>
          </PageHeaderContainer>
          <FarmersStepper
            steps={farmerSteps}
            questionnaireSubmitHandler={questionnaireSubmitHandler}
          />
          {successModalOpen && successModalData.isVisible && (
            <Modal
              hideSecondaryAction={true}
              maskClosable={false}
              onCancel={() => handleModalClose(successModalData)}
              onClose={() => handleModalClose(successModalData)}
              maxWidth={'25rem'}
              isOpen={true}
              footer={
                <SuccessModalButtonContainer>
                  <Button variant="Primary" onClick={() => handleModalSubmit(successModalData)}>
                    {successModalData.button_text}
                  </Button>
                  <Button
                    variant="Stroked"
                    color="Black"
                    onClick={() => handleModalClose(successModalData)}
                  >
                    {t('farmers_success_model_close_button')}
                  </Button>
                </SuccessModalButtonContainer>
              }
            >
              <SuccessModalContainer>
                <SuccessLogo />
                <SuccessModalDescription>
                  {successModalData.title}
                  <br />
                  {successModalData.subtitle}
                </SuccessModalDescription>
              </SuccessModalContainer>
            </Modal>
          )}
        </>
      )}
    </FarmersQuestionnaireContainer>
  );
};
